import React, { useEffect, useRef, useState } from 'react'
import style from './UserGuide.module.css'
import { useActiveSection } from '../../Utils/helper';
import { Link } from 'react-router-dom';
import Accordion from './Accordian';
import contactUsStyle from "../TermAndPolicy/TermAndPolicy.module.css"
import { useSelector } from 'react-redux';


const UserGuide = ({activeTab}) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false)


  const User=useSelector(state=>state.User)
  const handlePlayPause = async () => {
    const video = videoRef.current;
    if (!video) return;
  
    if (isPlaying && !video.paused) {
      video.pause();
      setIsPlaying(false);
    } else if (!isPlaying && video.paused) {
      try {
        await video.play(); // wait for play to succeed
        setIsPlaying(true);
      } catch (err) {
        console.error("Video play failed:", err);
      }
    }
  }
  const handleMute = () => {
    const video = videoRef.current;
    if (video) {
      video.muted = !video.muted;
    }
  }
const FAQ=[{
  title:"What is AuthNumber?",

  content:`AuthNumber is a comprehensive exit employee repository helping employers in handling incoming verification requests. A one-of-its-kind product from AuthBridge, AuthNumber provides an online portal for employers to upload their ex-employee data and let go of all efforts and worries related to handling incoming verification requests.
AuthNumber also helps verifiers in verifying candidate details by providing an authentic repository of readily available employee data contributed directly from the employers themselves. Complete automation with defined users, access and visibility makes it completely secure for both employers and verifiers.`
},

{
  title:"Where does the data on AuthNumber come from?",

  content:`Employers directly contribute authentic data of their ex-employees on AuthNumber.`
},
{

  title:"What type of employers can use AuthNumber?",

  content:`Employers from across all sectors and industries can use AuthNumber to contribute/verify employee data`
},
{
  title:"How is data security and access ensured?",

  content:"AuthNumber data is maintained across highly secure servers and access is provided to selected data. Employers can view and modify data limited to what they have uploaded; separating data shared by a particular employer with the data shared by rest of the employers. Access rights are enabled at each level to ensure complete security."
},
{
  title:"Who can be a Verifier?",

  content:"A person or an organisation from any sector/ industry looking for verifying their employees can become a verifier."
},
{
  title:"How to become a Registered Verifier?",

  content:"You can become a verifier by filling up a form which is at the bottom section of the website or by sending us a verification request at authnumber-support@authbridge.com"
},
{
  title:"Who can be a Issuer (Employer)?",

  content:"A person or an organisation from any sector/ industry looking for outsourcing ex-employee verification handling can become a issuer (employer)."
},

{
  title:"How can I get the verification done from AuthNumber?",

  content:`For Registered Verifiers
1.  Log in to AuthNumber.com
2.  Create a verification request
3.  Fill Employee Name and relevant details
4.  Upload Authorization Release Note (ARN)
5.  Receive Verification result
 
For Non-Registered Verifiers
Alternately, if you are not a registered as a verifier on our portal, you can send us a verification request at authnumber-support@authbridge.com`
},
{
  title:"What if AuthNumber does not have the data of a candidate?",

  content:"Verifier can raise a request on the portal or send us an email at authnumber-support@authbridge.com with employee details for whom no data is available in the database."
},

{
  title:"What is an Appeal?",

  content:"Verifier can raise an appeal for any mismatch in the data provided by the employee and that available in AuthNumber database."
},
{
  title:"What is a Request?",

  content:"Verifier can raise a “Request” when no data is available in the AuthNumber database for the verification request raised."
},
{
  title:"Can I conduct a check on someone without his/her knowledge?",

  content:"No, an employee must give his consent for conducting background check on him/her. During verification, verifiers must upload an ARN- Authorization Release Note, signed by the employee giving his/her consent on background screening check."
},
{
  title:"I have the candidate's consent via a Letter of Authorization. Can I enter data on his/her behalf?",

  content:"Yes, you can enter the candidate's information provided that you upload the employee's ARN- Authorization Release Note, signed by the employee giving his/her consent on background screening check."
}
]


  const TableOfContent=()=>{
    return (
      <>
      <span className={style.Tableheading}>Table Of Content</span>
      <nav>
        <ul className={style.ul}>
          <li className={style.li}><a href="#section1">AuthN API 2.0</a></li>
          <li className={style.li}><a href="#section2">Explore the AuthN API</a></li>
          <li className={style.li}><a href="#section3">Sample Application</a></li>
          <li className={style.li}><a href="#section4">API v2 and v3</a></li>
          <li className={style.li}><a href="#section5">Authentication</a></li>
          <li className={style.li}><a href="#section6">Download the Postman Collection</a></li>
        </ul>
      </nav>

      </>
    );

  }
  return (
    <div className={style.userGuide}>
      {activeTab=="EU-Rights"&&
      <>
      <div>
        <h1>EU - Data Subject Rights Process</h1>
        <span>AuthNumber is a platform where you can verify the user and issue the documents to holder</span>
        
      </div>
      <hr/>

      <div style={{display:"flex", width:"60%", flexDirection:"column"}}>
      <div id='section5'>
      <p className={style.paragraph}>If you need to raise a request to process EU-Data Subject Rights (DSR), kindly write to us at <a href='datasubjectrights@authbridge.com' target='_blank'>datasubjectrights@authbridge.com</a>. along with the mandatory details in the below-mentioned format.</p>
      </div>
      <div id="section6">
      <p className={style.paragraph}>To know more about these rights, please visit our privacy policy.</p>
      </div>
       <table style={{ borderCollapse: "collapse", width: "50%" , margin:"15px 0px"}}>
                  <tbody>
                    <>
                      <tr>
                        <td
                          style={{
                            border: "2px solid #ddd",
                            padding: "8px",
                            fontWeight: "500"
                          }}
                        >
                          Type of request
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          {`<Data Subject Right which is to be processed.>`}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "2px solid #ddd",
                            padding: "8px",
                            fontWeight: "500",
                          }}
                        >
                          Name of the data subject
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          {`<Candidate name>`}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "2px solid #ddd",
                            padding: "8px",
                            fontWeight: "500",
                          }}
                        >
                          Employee ID
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          {`<Unique Employee ID>`}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "2px solid #ddd",
                            padding: "8px",
                            fontWeight: "500",
                          }}
                        >
                          Any Additional Comments
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          
                        </td>
                      </tr>
                    </>
                  </tbody>
                </table>
                <div>
                Disclaimer - For timely and effective execution of DSR requests of EU Data Subject, always send it on the above-mentioned email ID. Sharing it to any other source may lead to delay/miss to comply
                </div>
      </div>
      </>}
      {activeTab=="FAQTAB" &&
      <>
      <div>
        <h1>FAQ</h1>
        <hr/>
        
      </div>
      <div>
        {FAQ.map((i,index)=>{
          return(                  
            <Accordion title={i.title} content={i.content}/>
          )})}
      </div>
      </>
      }
      {
        activeTab=="Registration-Kit" &&

        <div>
          <table style={{ borderCollapse: "collapse", width: "50%" , margin:"15px 0px"}}>
                  <tbody>
                    <>
                      <tr>
                        <td
                          style={{
                            border: "2px solid #ddd",
                            padding: "8px",
                            fontWeight: "500"
                          }}
                        >
                          Pan Number
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        AAFCD5862R
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            border: "2px solid #ddd",
                            padding: "8px",
                            fontWeight: "500",
                          }}
                        >
                          GSTIN
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        06AAFCD5862R017
                        </td>
                      </tr>
                    </>
                  </tbody>
                </table>
        </div>
      }
      {
        activeTab=="ContactUS" &&
        // <div className={contactUsStyle.TermAndPolicy}>
        <div>
        
                          <h1>Contact Us</h1>
        
        
                          <div className={contactUsStyle.ContactUs} style={{padding:"0px"}}>
                            <h1>Get in Touch with Our Team</h1>
                            <p className={contactUsStyle.paragraph}>We're here to answer your questions, and help you find the best solutions to your software needs.</p>
                            <p className={contactUsStyle.paragraph}>Reach out to us, and let's start building something great together.</p>
                            <div style={{width:"100%", display:"flex", justifyContent:"space-between"}}>
                          <div className={contactUsStyle.ContactUsData}>
                            <div style={{width:"100%", display:"flex", flexDirection:"column", alignItems:"center"}}>
                                <h1>Let's Talk</h1>
                                {/* <div className={style.userInputBox}>
                                                <label htmlFor="firstname">Name</label>
                                                <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                              {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                                </div>
                                <div className={style.userInputBox}>
                                                <label htmlFor="firstname">Email</label>
                                                <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                              {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                                </div>
                                <div className={style.userInputBox}>
                                                <label htmlFor="firstname">Company Name</label>
                                                <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                              {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                                </div>
                                <div className={style.userInputBox}>
                                                <label htmlFor="firstname">Subject</label>
                                                <input type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                              {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                                </div>
                                <div className={style.userInputBox}>
                                                <label htmlFor="firstname">Message</label>
                                                <textarea type="text" id="firstname" name="firstname" value="ABC" placeholder="e.g.Bonnie Green" />
                                              {error.fullname && <span style={{color:"red",fontWeight:"500"}}>{error.fullname}</span>}
                                </div> */}
                                <div className={contactUsStyle.paragraph}>
                                If you would like to outsource the employment verification of your ex-employees or would like to come onboard as our registered Verifying partner
                                </div>
                                <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150"
             viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
             aria-label="Contact support">
          <path d="M4 12a8 8 0 0116 0" />
          <rect x="3" y="11" width="3" height="5" rx="1" />
          <rect x="18" y="11" width="3" height="5" rx="1" />
          <circle cx="12" cy="10" r="2.5" />
          <path d="M16 16v.5a3.5 3.5 0 01-3.5 3.5H9.5" />
        </svg>
        
        </div>
                            </div>
                            </div>
                            <div>
                                <h1>Prefer to Direct Approch?</h1>
                                <div style={{margin:"1rem"}}>
                                <p className={contactUsStyle.paragraph}>Support</p>
                                <div style={{display:"flex", gap:"10px"}}>
                                    <img src='/mail.svg' alt='mail.svg' style={{marginBottom:"1rem"}}/>
                                    <p className={contactUsStyle.paragraph}>authnumber-support@authbridge.com</p>
                                </div>
                                <div style={{display:"flex", gap:"10px"}}>
                                    <img src='/phonecall.svg' alt='phonecall.svg' style={{width:"22px", height:"22px", marginBottom:"1rem"}}/>
                                    <p className={contactUsStyle.paragraph}>+91 9310658619</p>
                                </div>
                                </div>
                                <div style={{margin:"1rem"}}>
                                <p className={contactUsStyle.paragraph}>Corporate Headquaters</p>
                                <p className={contactUsStyle.paragraph}>Authbridge Research Services Pvt. Ltd.</p>
                                <p className={contactUsStyle.paragraph}>8th Floor, Smartworks Golf View Towers,</p>
                                <p className={contactUsStyle.paragraph}>Tower-B, Sector 42,</p>
                                <p className={contactUsStyle.paragraph}>Gurgaon-122009</p>
                                
                                <p className={contactUsStyle.paragraph}>Haryana, India</p>
        
                                </div>
                                
                                
                            </div>
                          </div>

                          {/* <div className="flex flex-col items-center gap-4 mt-4">
                            <video ref={videoRef} width="600" className="rounded-lg shadow-md" controls>
                              <source src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4" type="video/mp4" />
                            </video>
                          </div> */}
                          </div>
        
                          </div>
      }

      {
        activeTab=="DOCS" &&
        <div>

          <h1>Docs</h1>
          <hr/>
          {User.user_type=="Issuer" && 
          <div className="flex flex-col mt-4">
            <h1 style={{color:"#1c64f2"}}>How to create Forms and Templates</h1>
              <video ref={videoRef} width="1000" className="rounded-lg shadow-md" controls>
              <source src="/How_to_create_new_template_or_form.mp4" type="video/mp4" />
            </video>

            <h1 style={{marginTop:"5rem",color:"#1c64f2"}}>How to issue a new document</h1>
              <video ref={videoRef} width="1000" className="rounded-lg shadow-md" controls>
              <source src="/How_to_issue_new_document.mp4" type="video/mp4" />
            </video>
        </div>}
        {
          User.user_type=="Verifier" &&
          <div className="flex flex-col mt-4">
            <h1 style={{color:"#1c64f2"}}>How to create Forms and Templates</h1>
              <video ref={videoRef} width="1000" className="rounded-lg shadow-md" controls>
              <source src="/How_to_create_new_template_or_form.mp4" type="video/mp4" />
            </video>
            <h1 style={{marginTop:"5rem",color:"#1c64f2"}}>How to raise Verification Request</h1>
              <video ref={videoRef} width="1000" className="rounded-lg shadow-md" controls>
              <source src="/How_to_raise_a_verification_request.mp4" type="video/mp4" />
            </video>

            </div>
          
        }
          <div>
          </div>
        </div>
      }
    </div>
  )
};

export default UserGuide;
